module.exports = __webpack_public_path__ + "fonts/SegoeUI.076522f.woff";